"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const trending = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-trending` : '') + (description ? ` desc-trending` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-trending"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-trending"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.5 0.25H5.5C5.08579 0.25 4.75 0.585786 4.75 1V12L4.75685 12.1018C4.80651 12.4678 5.1203 12.75 5.5 12.75H8.403L8.4033 23C8.4033 23.7382 9.35754 24.0323 9.77314 23.4223L19.1198 9.702L19.1726 9.61248C19.4162 9.12712 19.067 8.52975 18.5 8.52975L15.111 8.529L19.1531 1.36865C19.4353 0.868689 19.0741 0.25 18.5 0.25ZM17.214 1.75L13.1735 8.91109L13.128 9.00605C12.9373 9.48598 13.2884 10.0297 13.8266 10.0297L17.082 10.029L9.903 20.566L9.9033 12L9.89645 11.8982C9.84679 11.5322 9.53299 11.25 9.1533 11.25H6.25V1.75H17.214Z",
    fill: "inherit"
  }));
};
var _default = exports.default = trending;